import { withGeneratedLinks } from "../affiliateLinks";
import affiliateLinks from "../affiliateLinks.be.json";
import { BE_PROVIDERS } from "../providers.be";
import {
  BE_DEFAULT_REGION,
  BE_REGIONS,
  getBeEnergyTaxRate,
  isBeRegionId,
} from "../taxes.be";
import type { CountryConfig } from "./types";

export const BE_CONFIG: CountryConfig = {
  country: "be",
  domain: "epexprijzen.be",
  siteTitle:
    "Live energieprijzen voor dynamische stroom in België | EpexPrijzen.be",
  siteTagline: "Actuele energieprijzen in België",
  metaDescription:
    "Actuele energieprijzen in België - Vergelijk energieprijzen en energieleveranciers",
  energyTaxLabel: "Accijnzen en heffingen",
  htmlLang: "nl-BE",
  hreflang: "nl-BE",
  contactEmail: "info@epexprijzen.be",
  vatRate: 0.06,
  feedInVatRate: 0,
  regions: BE_REGIONS,
  defaultRegionId: BE_DEFAULT_REGION,
  getEnergyTaxRate: (date, regionId) =>
    getBeEnergyTaxRate(
      date,
      regionId && isBeRegionId(regionId) ? regionId : BE_DEFAULT_REGION
    ),
  expectedPriceSource: null,
  providers: withGeneratedLinks(BE_PROVIDERS, affiliateLinks),
  ctaUrl: "https://mijnbatterij.eu",
  ctaName: "Mijnbatterij",
  evccTemplate: null,
  plausibleDomain: "epexprijzen.be",
  alternateSite: {
    url: "https://epexprijzen.nl",
    label: "Nederland",
    flagEmoji: "🇳🇱",
    hreflang: "nl-NL",
  },
};
